import { Input } from "cd-eft/components/common/Input";
import { observer } from 'mobx-react';
import React, { Fragment, useRef, useEffect } from 'react';
import { FormulaBanner } from "../Common/FormulaBanner";
import { ComboBox } from "cd-eft/components/common/ComboBox";
import {
    InputContainer,
    ResultsContainer,
    ImageContainer,
    DescriptionContainer,
    FormulaPrintModalContainer,
} from "../template/FormulaFormTemplates";
import { WaterControlVM } from "./WaterControlVM";
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const WaterControlComponent = (props) => {
    const vm = useRef(new WaterControlVM(props)).current;
    useEffect(() => {
        vm.getFormData(`${props.section}_${props.title}_${props.id}`);
    }, []
    );

    return (
        <Fragment>
            <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
            <div className="row formula-content">
                <InputContainer
                    computeCallback={() => {
                        vm.computeWaterControl();
                    }
                    }
                    printCallback={() => {
                        vm.launchAndExport();
                    }
                    }
                    isLoading={vm.isLoading}
                    disableCompute={vm.disableComputeBtn}
                    disablePrint={vm.disablePrintBtn}
                >
                    <span className="input-help-header" >
                        <a href={vm.helpLink} target="_blank">Help select n value <img src={pdfLogo} alt={'PDF logo'} /></a>
                    </span>
                    <h2 className='sections-heading' >Inlet</h2>
                    <ComboBox
                        idAndName="Inlet-Entry"
                        label="Inlet Entry"
                        aria-label="inlet entry"
                        valid={!vm.formValidation.inletEntry}
                        value={vm.waterControlFormData.inletEntry}
                        onChange={vm.handleWaterControlForm}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        options={vm.entryOptions}
                        errorMsg={''}
                        required={true}
                        className={`inlet-entry${vm.waterControlErrorClass('inletEntry')}`}
                    />
                    <Input
                        label="Pipe Length (ft)"
                        idAndName="pipe-length"
                        valid={!vm.formValidation.pipeLength}
                        value={vm.waterControlFormData.pipeLength}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        className={vm.waterControlErrorClass('pipeLength')}
                        min={0.01}
                    />

                    <Input
                        label="Pipe Diameter (in)"
                        idAndName="pipe-diameter"
                        valid={!vm.formValidation.pipeDiameter}
                        value={vm.waterControlFormData.pipeDiameter}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.02}
                        className={vm.waterControlErrorClass('pipeDiameter')}
                    />
                    <Input
                        label="Manning's n"
                        idAndName="inlet-manning"
                        valid={!vm.formValidation.inletManning}
                        value={vm.waterControlFormData.inletManning}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.0001}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.0001}
                        className={vm.waterControlErrorClass('inletManning')}
                    />
                    <h2 className='sections-heading' >Weir</h2>
                    <Input
                        label="Weir Length (in)"
                        idAndName="weir-length"
                        valid={!vm.formValidation.weirLength}
                        value={vm.waterControlFormData.weirLength}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.01}
                        className={vm.waterControlErrorClass('weirLength')}
                    />
                    <h2 className='sections-heading' >Outlet</h2>
                    <Input
                        label="Pipe Length (ft)"
                        idAndName="pipe-length-out"
                        valid={!vm.formValidation.pipeLengthOut}
                        value={vm.waterControlFormData.pipeLengthOut}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.01}
                        className={vm.waterControlErrorClass('pipeLengthOut')}
                    />
                    <Input
                        label="Pipe Diameter (in)"
                        idAndName="pipe-diameter-out"
                        valid={!vm.formValidation.pipeDiameterO}
                        value={vm.waterControlFormData.pipeDiameterO}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.02}
                        className={vm.waterControlErrorClass('pipeDiameterO')}
                    />
                    <Input
                        label="Manning's n"
                        idAndName="outlet-manning"
                        valid={!vm.formValidation.outletManning}
                        value={vm.waterControlFormData.outletManning}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.0001}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.0001}
                        className={vm.waterControlErrorClass('outletManning')}
                    />
                    <h2 className='sections-heading' >Elevations</h2>
                    <Input
                        label="Maximum Pool Elevation (ft)"
                        idAndName="maximum-pool-elevation"
                        valid={!vm.formValidation.maxPoolElevation}
                        value={vm.waterControlFormData.maxPoolElevation}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.01}
                        className={vm.waterControlErrorClass('maxPoolElevation')}
                    />
                    <Input
                        label="Pipe Inlet Elevation (ft)"
                        idAndName="pipe-inlet-elevation"
                        valid={!vm.formValidation.pipeInletElevation}
                        value={vm.waterControlFormData.pipeInletElevation}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.01}
                        className={vm.waterControlErrorClass('pipeInletElevation')}
                    />
                    <Input
                        label="Weir Elevation (ft)"
                        idAndName="weir-elevation"
                        valid={!vm.formValidation.weirElevation}
                        value={vm.waterControlFormData.weirElevation}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0.01}
                        className={vm.waterControlErrorClass('weirElevation')}
                    />
                    <Input
                        label="Structure Invert Elevation (ft)"
                        idAndName="structure-invert-elevation"
                        valid={!vm.formValidation.structureInvertElevation}
                        value={vm.waterControlFormData.structureInvertElevation}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0}
                        className={vm.waterControlErrorClass('structureInvertElevation')}
                    />
                    <Input
                        label="Pipe Outlet Elevation (ft)"
                        idAndName="pipe-outlet-elevation"
                        valid={!vm.formValidation.pipeOutletElevation}
                        value={vm.waterControlFormData.pipeOutletElevation}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0}
                        className={vm.waterControlErrorClass('pipeOutletElevation')}
                    />
                    <Input
                        label="Tailwater Elevation (ft)"
                        idAndName="tailwater-elevation"
                        valid={!vm.formValidation.tailwaterElevation}
                        value={vm.waterControlFormData.tailwaterElevation}
                        type="number"
                        onChange={(e) => {
                            vm.handleWaterControlForm(e);
                        }}
                        step={0.01}
                        onBlur={(e) => vm.handleInputOnBlur(e.target.name, e.target.value)}
                        onKeyDown={vm.handleOnKeyDown}
                        min={0}
                        className={vm.waterControlErrorClass('tailwaterElevation')}
                    />
                </InputContainer>
                <div className="col formula-information">
                    {vm.hasResults ? (
                        <div className="row formula-results">
                            <ResultsContainer>
                                <div className="col result-value-group">
                                    <div className="grid-row">
                                        <div className="">
                                            <table className="usa-table usa-table--stacked usa-table--striped table-mobile">
                                                <thead className="theader">
                                                    <tr>
                                                        <th scope="col">
                                                            <div className="headers result-label">
                                                                Pool Elevation (ft)
                                                            </div>
                                                        </th>
                                                        <th scope="col">
                                                            <div className="headers result-label">
                                                                Discharge (cfs)
                                                            </div>
                                                        </th>
                                                        <th scope="col">
                                                            <div className="headers result-label">
                                                                Water Elevation US of Weir (ft)
                                                            </div>
                                                        </th>
                                                        <th scope="col">
                                                            <div className="headers result-label">
                                                                Water Elevation DS of Weir (ft)
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {vm.calculationResults.map((item, i) => {
                                                        return (
                                                            <tr id={'row' + i} key={'key' + i} className="tr" >
                                                                <td className="blank" aria-label="">
                                                                    {item.poolElevation && item.poolElevation !== '' ? vm.roundingHelperString(parseFloat(item.poolElevation), 2) : '--'}
                                                                </td>
                                                                <td className="blank" aria-label="">
                                                                    {item.discharge && item.discharge !== '' ? vm.roundingHelperString(parseFloat(item.discharge), 2) : '--'}
                                                                </td>
                                                                <td className="blank" aria-label="">
                                                                    {item.weirStageElevation && item.weirStageElevation !== '' ? vm.roundingHelperString(parseFloat(item.weirStageElevation), 2) : '--'}
                                                                </td>
                                                                <td className="blank" aria-label="">
                                                                    {item.downStreamElevation && item.downStreamElevation !== '' ? vm.roundingHelperString(parseFloat(item.downStreamElevation), 2) : '--'}
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </ResultsContainer>
                        </div>
                    ) : ''}
                    <div className="row formula-description">
                        <DescriptionContainer>
                            <p>{vm.formDescription}
                                &nbsp;
                                <a target="_blank" href={vm.bannerHelpLink}>
                                    Learn More
                                    <img src={pdfLogo} alt={'PDF logo'} />
                                </a>
                            </p>
                        </DescriptionContainer>
                    </div>
                    <div className="row formula-images">
                        <ImageContainer>
                            <img
                                className="water-control-img"
                                src={vm.image}
                                alt={vm.hydraulicFormulaImageDescription}
                                title={vm.formulaTitle}
                            />
                        </ImageContainer>
                    </div>
                </div>
                {vm.isLoading && <Loader message={''} />}
            </div>
            <FormulaPrintModalContainer
                vm={vm}
                inputs={vm.exportedInputs}
                results={vm.exportedResults}
                images={[vm.image]}
                formulaName={vm.formulaTitle}
                tableData={true}
            />
        </Fragment>
    );
};

export const WaterControlFormula = observer(WaterControlComponent); 